import React from "react";

export default function ApiLink(props) {
  const { name } = props;
  return (
    <code>
      <a href={"#" + name}>{name}</a>
    </code>
  );
}
